var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('ExportCard')],1)],1),_c('v-row',[_c('v-col',[_c('ChartCard')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }